import { axios } from '@Root/API'

export const edit = payload => {
  return axios.post('hesa_root_url', payload)
}
